import { AbsoluteFill } from "remotion";
import { COLORS, FONTS, Fonts } from "../../coldcompute";

/**
 * YouTube thumbnail (1280×720). Focal subject: a generated widget with an
 * Approve+Send button — UI that carries an action — plus the SHIPPED / BEHIND-A-FLAG
 * status labels so the honesty stance reads in one frame. Promise: NOT TEXT — UI.
 */
export const ActionOrientedDynamicUIThumb: React.FC = () => (
  <AbsoluteFill
    style={{
      background: `radial-gradient(95% 95% at 76% 18%, #08160f 0%, ${COLORS.bg} 52%, ${COLORS.bg2} 100%)`,
      alignItems: "flex-start",
      justifyContent: "center",
      flexDirection: "column",
      padding: "0 78px",
    }}
  >
    <Fonts />

    {/* faint scanline grain */}
    <AbsoluteFill
      style={{
        opacity: 0.06,
        mixBlendMode: "screen",
        backgroundImage: "repeating-linear-gradient(0deg, #fff 0 1px, transparent 1px 3px)",
      }}
    />

    {/* focal: a generated widget panel with a live action button, off to the right */}
    <div
      style={{
        position: "absolute",
        right: 56,
        top: 150,
        width: 430,
        transform: "rotate(-4deg)",
        background: COLORS.panel,
        border: `2px solid ${COLORS.green}`,
        borderRadius: 14,
        padding: "20px 22px",
        boxShadow: `0 0 80px -18px ${COLORS.green}`,
      }}
    >
      <div style={{ fontFamily: FONTS.mono, fontSize: 19, letterSpacing: "0.14em", textTransform: "uppercase", color: COLORS.green, marginBottom: 14 }}>
        agent → built this
      </div>
      <div
        style={{
          border: `1px solid ${COLORS.line}`,
          borderRadius: 8,
          padding: "12px 14px",
          fontFamily: FONTS.mono,
          fontSize: 17,
          color: COLORS.dim,
          lineHeight: 1.7,
          background: COLORS.panel2,
        }}
      >
        <div>To: customer@acme.com</div>
        <div style={{ color: COLORS.text }}>— editable draft —</div>
      </div>
      <div
        style={{
          marginTop: 16,
          fontFamily: FONTS.mono,
          fontSize: 22,
          fontWeight: 600,
          color: COLORS.bg,
          background: COLORS.green,
          borderRadius: 8,
          padding: "12px 18px",
          textAlign: "center",
        }}
      >
        Approve + Send
      </div>
    </div>

    {/* kicker */}
    <div
      style={{
        fontFamily: FONTS.mono,
        fontSize: 30,
        letterSpacing: "0.2em",
        textTransform: "uppercase",
        color: COLORS.cyan,
        marginBottom: 18,
      }}
    >
      ▍inputs · controls · actions
    </div>

    {/* headline */}
    <div
      style={{
        fontFamily: FONTS.display,
        fontWeight: 700,
        fontSize: 150,
        lineHeight: 0.9,
        letterSpacing: "-0.025em",
        color: COLORS.text,
      }}
    >
      MY AGENT
      <br />
      STOPPED <span style={{ color: COLORS.green }}>TALKING</span>
    </div>

    {/* footer: the honest status, in one line */}
    <div
      style={{
        display: "flex",
        gap: 14,
        marginTop: 28,
        alignItems: "center",
      }}
    >
      <span style={{ fontFamily: FONTS.mono, fontSize: 22, color: COLORS.green, border: `1px solid ${COLORS.green}66`, borderRadius: 6, padding: "4px 12px" }}>
        SHIPPED: read-only + P0
      </span>
      <span style={{ fontFamily: FONTS.mono, fontSize: 22, color: COLORS.amber, border: `1px solid ${COLORS.amber}66`, borderRadius: 6, padding: "4px 12px" }}>
        SPINE: behind a flag
      </span>
    </div>
  </AbsoluteFill>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
